<template>
  <div class="newsMain">
    <!-- 流通行业信息化整体架构 -->
    <PcCirculate class="PC"/>
    <MdCirculate class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdCirculate from './MdCirculate.vue'
// pc端
import PcCirculate from './PcCirculate.vue'
export default {
  name: 'newsMain',
  components: {
    PcCirculate,
    MdCirculate
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
